

define(['angular', 'squid/index'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('fi.apis', ['squid']).factory('$fiApis', function ($q) {
        return {
            patchCvv: function patchCvv(checkoutSession) {
                var cvvData = checkoutSession.get('cvvData');

                if (cvvData) {
                    return checkoutSession.action('patchCvv', {
                        data: {
                            id: cvvData.id,
                            cvv: cvvData.security_code,
                            type: cvvData.type,
                            number: cvvData.number
                        }
                    });
                }

                return $q.when();
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/fi/lib/fiApis.js
// module id = ./components/xo-models/src/fi/lib/fiApis.js
// module chunks = 1